<template>
  <div v-loading="fullscreenLoading">
    <div style="margin-left: 10.5%">
      <div style="padding-top: 20px"></div>
      <div
        class="Rectangle-5"
        v-bind:style="{ height: +(windowHeight - 200) + 'px' }"
      >
        <div style="padding: 3%">
          <div style="display: inline-block">下单最低金额：</div>
          <div style="display: inline-block; margin-left: 20px">
            <el-input
              style="display: inline-block"
              type="number"
              v-model="form.minTotal"
              placeholder="请输入数量"
            ></el-input>
          </div>
          <div style="margin-top: 20px">
            <el-button
              @click="onEditConfirm()"
              style="background-color: #1bb24b; width: 125px"
              type="success"
              >确认修改</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "orderTotal",
  data() {
    return {
      fullscreenLoading: false,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,

      searchKeyword: "",

      currentData: {},
      currentPage: 1,

      tableDataList: [],
      tableDataTotal: 0,

      form: {
        minTotal: "",
      },
    };
  },
  mounted() {},
  created() {
    this.onCheckloginRole();
    this.onFetchTableData();
  },
  methods: {
    // check if  login
    onCheckloginRole() {
      // var temp = localStorage.getItem("auth");
      // if (temp == undefined || temp != "b60afdc1f3657130c165d32743603a59") {
      //     this.$router.push("/login");
      // }
      var temp = localStorage.getItem("auth");
      this.axios
        .post(this.$urlGlobal + "adminCheck", {
          auth: temp,
        })
        .then((res) => {
          if (res.data.code == -1) {
            this.$router.push("/login");
            localStorage.removeItem("auth");
      window.location.reload();
          }
        });
    },

    // search  table by name
    onSearchTableData() {
      // init the page and fetch data
      this.currentPage = 1;
      this.onFetchTableData();
    },
    // fetch table data also with condition
    onFetchTableData() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchOrderRestriction", {})
        .then((res) => {
          this.fullscreenLoading = false;
          this.form.minTotal = res.data.data.minTotal;
        });
    },

    // add new  operation
    onDialogBoolAddNewOpen() {
      this.boolAddNew = true;
    },
    onDialogBoolAddNewClose() {
      this.boolAddNew = false;
      // also close edit because they use same form
      this.boolEdit = false;
      this.form = {
        imgUrl: "",
      };
    },

    // confirm orderNum change
    onEditConfirm() {
      if (this.form.minTotal == "") {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminEditOrderMinTotal", {
          minTotal: this.form.minTotal,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 1) {
            this.$message({
              message: "修改失败",
              type: "warning",
            });
            return;
          } else {
            this.$message({
              message: "修改成功",
              type: "success",
            });
          }
          this.onFetchTableData();
        });
    },

    // table operation
    onDialogWithData(scope, e) {
      this.currentData = scope.row;
      switch (e) {
        case "edit":
          this.onDialogBoolEditOpen();
          break;
      }
    },
  },
};
</script>

